export default {
	"ufv": {
		"inMantenimiento": false,
		"name": "ufv",
		"basic": {
			"default": "#003865",
			"alternative": "#ffb81c",
			"fontAlternative": "#202020",
			"darkMode": "#003865"
		},
		"button": {
			"default": "#fff",
			"font": "#303338",
			"darkMode": "#003865"
		},
		"soft_basic": {
			"default": "#97999b",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"text_important": {
			"default": "#FF5D74",
			"darkMode": "#f3f3f3"
		},
		"dark_black": {
			"default": "#003865",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/ufv/logo.svg",
		"logocolor": "/static/img/brands/ufv/logo-color.png",
		"logodarkmode": "/static/img/brands/ufv/logo-white.svg",
		"logoSize": "medium",
		// "background": "/static/img/brands/ufv/background.jpg",
		"emailContacto": "c.profesionales@ufv.es",
		"emailInscripcion": "c.profesionales@ufv.es",
		"emailProblemas": "c.profesionales@ufv.es",
		"emailJuridica": "c.profesionales@ufv.es",
		"emailIngenieria": "c.profesionales@ufv.es",
		"emailEconomica": "c.profesionales@ufv.es",
		"emailSanitaria": "c.profesionales@ufv.es",
		"emailEducacion": "c.profesionales@ufv.es",
		"emailRRII": "c.profesionales@ufv.es",
		"emailInternacional": "c.profesionales@ufv.es",
		"hideSAML": true,
		"ownpopup_info": {
			"editar_personales": {
				"titulo": "Edición de datos personales",
				"texto": "Si alguno de los datos no editables no es correcto, por favor, accede a tu intranet para modificarlos."
			}
		},
		"footer": {
			"es": {
				"copyright": {
					"link": "https://www.ufv.es/",
					"text": "Fundación Universidad Francisco de Vitoria © {year} Todos los derechos reservados"
				},
				"links": {
					"Aviso Legal": "https://www.ufv.es/aviso-legal",
					"Política privacidad": "https://www.ufv.es/politica-de-privacidad",
					"Política de Cookies": "https://www.ufv.es/politica-de-cookies/",
				}
			}
		},
		"fonts": {
			"link": "family=Arimo:300,400,500,700,800",
			"principal": "'Arimo', sans-serif",
			"secundaria": "'Arimo', sans-serif"
		},
		"banner_home_empresas": {
			"src": "/static/img/brands/ufv/banner-foro-empresas.webp",
			"link": "/static/docs/dossier-foro-empleo-ufv-2026.pdf",
			"external": true,
			"download": true
		},
		"banner_home_alumnos": {
			"src": "/static/img/brands/ufv/banner_home_alumnos.jpg",
			"link": "https://portalforoempleo.ufv.es",
			"external": true
		},
		"ownstyles": "/static/img/brands/ufv/style.css",
		"logintexts": {
			"es": {
				"antiguos": "Antiguo Alumno",
				"estudiantes": "Alumno",
				"empresas": "Empresa"
			}
		},
		"moduloOrientacion": false,
		"canCambiarPracticas": true,
		"busquedasGuardadas": false,
		//PROPUESTA DE PRACTICAS
		"instruccionesPropuestaPracticas": "",
		"showPropuestaPracticas": true,
		"ocultarInfoAux": true,

		//SETEO DE LAS OFERTAS
		"requestInfoSeleccionado": true,
		"requestEmpresaDestino": true,
		"CVRequired": true,
		"inscripcionExterna": true,
		"programasInformaticosNoPersonalizables": true,
		"requestDatosTutorEnOferta": true,
		"hideCamposTutor": ["cargo", "departamento"],
		"showDireccionEmpresa": true,
		"requestDatosFirmanteEnPropuesta": false,
		"requestDatosFirmanteEnOferta": true,
		"busquedaPuestoEmpresa": true,
		"listBusquedaPractica": ['areaFuncional', 'tiposFormacion', 'tipoModalidadAsistencia'],
		"renunciaPracticasSET": true,

		"niveles": [
			{
				id: "cicloFormativo",
				active: true,
				label: {
					"es": "Ciclo Formativo",
					"ca": "Ciclo Formativo"
				}
			},
			{
				id: "grado",
				active: true,
				label: {
					"es": "Grado",
					"ca": "Grau"
				}
			},
			{
				id: "postgrado",
				active: true,
				label: {
					"es": "Postgrado",
					"ca": "Postgrau"
				}
			},
			{
				id: "doctorado",
				active: true,
				label: {
					"es": "Doctorado",
					"ca": "Doctorat"
				}
			}
		],


		"camposOferta": {
			"remuneracion": true,
			"ayudaEstudio": {
				"label": {
					"es": "Remuneración(€ brutos/mes)"
				},
				"showIn": ['Practicas']
			},
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['Practicas', 'Empleo'],
				"showrequired": true
			},
			"empresaDestino": {
				"showIn": ['Empleo', 'Practicas']
			},
			"descripcion": {
				"label": {
					"Empleo": {
						"es": "Descripción del puesto*",
					},
					"Practicas": {
						"es": "Descripción del puesto*"
					}
				}
			},
			"experiencia": {
				"showIn": ['Empleo'],
			},
			"motivosexclusion": {
				"showIn": ['Empleo', 'Practicas']
			},
			// "paraEstudiantesUltimoCurso": {
			// 	"showIn": ['Practicas'],
			// },
			/* 			"modalidad": {
							"showIn": ['Empleo', 'Practicas']
						}, */
			"urlInformacionComplementaria": {
				"showIn": ['Empleo', 'Practicas']
			},
			"gestionOfertasConEstudiosPropuestos": {
				"showIn": ['Empleo', 'Practicas']
			},
			"observacionesEmpresa": true
		},

		"camposPracticas": {
			"puestoTrabajo": {
				"label": "Nombre práctica",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Funciones (tareas a desarrollar)",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"ayudaEstudio": {
				"label": "Remuneración (€ brutos/mes)",
			},
			"tutorEmpresa": {
				"titulacion": true,
				"dni": true,
				"telefono": true
			},
			"practicaRemunerada": {
				"label": {
					"es": "Práctica remunerada"
				},
				"showIn": ['Practicas']
			},
			"direccion": {
				"label": "direccion",
			},
			"tipoPracticaCurriExtracurri": true,
			"solicitudParaCentroEducativo": false,
		},

		//REGISTRO DE LA EMPRESA
		"requestStartUp": false,
		"requestTipoEmpresa": true,
		"requestDireccionFullContactoEmpresa": true,
		"requestDireccionContactoEmpresa": true,
		"hideDniFirmante": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
			"otrosector": {
				"visible": true,
			}
		},

		//CV DEL CANDIDATO
		"hasPresentacion": true,
		"quitarCampoDiscapacidad": true,
		"canEditPeriodoPracticas": true,
		"sectoresInteres": true,
		"checkIbanInPracticasConServicio": true,
		"hasDocumentacionPrivadaCV": true,
		"hasDocumentacionLigadaProcesos": true,
		"nivelesInformaticos": true,
		"personales": {
			"imagen": {
				"visible": true,
				"editable": true
			},
			"genero": {
				"visible": true,
				"editable": false
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": false
			},
			"idPaisSegundaNacionalidad": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": true,
				"editable": true
			},
			"emailestudiante": {
				"visible": true,
				"editable": false
			},
			"email": {
				"visible": true,
				"editable": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": false
			},
			"movil": {
				"visible": false,
				"editable": true
			},
			"telefono": {
				"visible": false,
				"editable": false
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": false,
					"hide": []
				},
				"2": {
					"visible": true,
					"editable": false,
					"hide": []
				}
			},
			"iban": {
				"visible": true,
				"editable": true
			},
			"SWIFT": {
				"visible": true,
				"editable": true
			},
			"identificador_secretaria": {
				"visible": true,
				"editable": true
			},
			"identificadorSeguridadSocial": {
				"visible": true,
				"editable": true
			}
		},

		"academicos": {
			"calificacion": {
				"editable": true
			},
			"centro": {
				"editable": true
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"adjunto": {
				"editable": true,
			},
			"enlace": {
				"editable": true,
			},

		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes": {},

		//DOCUMENTACIÓN DE EMPRESAS
		"haveDocumentosPracticas": true,
		"canSubirConvenios": false,
		"canCrearConvenios": true,

		//REGISTRO DE LOS ALUMNOS
		"ownlogin": {
			"hasEstudiante": true,
			"hasEgresado": true,
			"textoEstudiantes": {
				"es": "Accede a continuación para identificarte."
			},
			"textoEgresados": {
				"es": "Los antiguos alumnos de UFV disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad.<strong>Accede a continuación para identificarte.</strong>"
			},
			textoTutores: {
				es:
					"Los tutores de UFV disponen de usuario y contraseña propios para acceso a los servicios y sistemas de la Universidad."
			}
		},
		"infoAlumno": false,
		"requestTutoresPractica": true,
		"listadoOfertas": {
			"mostrarInscribirDesinscribir": false,
			"descripcionOferta": false,
			"fechaCaducidad": true
		},
	},
}


// WEBPACK FOOTER //
// ./src/brands/brands.js